module.exports = __webpack_public_path__ + "img/22.2a28aea9.svg";